import { render, staticRenderFns } from "./sendDetailOneYearNotify.vue?vue&type=template&id=05636679&scoped=true&"
import script from "./sendDetailOneYearNotify.vue?vue&type=script&lang=js&"
export * from "./sendDetailOneYearNotify.vue?vue&type=script&lang=js&"
import style0 from "./sendDetailOneYearNotify.vue?vue&type=style&index=0&id=05636679&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05636679",
  null
  
)

export default component.exports